import React from "react";
import { formatCompact, runwayFull } from "@/lib/currency";
import { cn } from "@/lib/utils";

// Transparent explanation of how a Survival Runway result is calculated.
// `scenario` is a metrics object (the "after" state) from calculations.js.
// `lostLabel` describes which income stopped (e.g. "Gaji Suami").
export function RunwayCalc({ scenario, lostLabel, showDefinition = true, dark = false, className }) {
  const muted = dark ? "text-zinc-400" : "text-zinc-500";
  const calcBox = dark
    ? "bg-white/10 text-zinc-200"
    : "bg-zinc-50 text-zinc-600";

  if (scenario.isPositive) {
    return (
      <div className={cn("space-y-2", className)} data-testid="runway-calc">
        {showDefinition && (
          <p className={cn("text-xs leading-relaxed", muted)}>
            Perkiraan kondisi keluarga jika{" "}
            {lostLabel ? <b>{lostLabel}</b> : "penghasilan utama terbesar"} berhenti
            hari ini dan pola pengeluaran tetap sama.
          </p>
        )}
        <div className={cn("rounded-xl px-3 py-2 font-mono text-[11px]", calcBox)}>
          Pendapatan tersisa masih menutup pengeluaran wajib — keluarga tetap
          punya sisa {formatCompact(scenario.monthlyBalance)}/bulan.
        </div>
      </div>
    );
  }

  return (
    <div className={cn("space-y-2", className)} data-testid="runway-calc">
      {showDefinition && (
        <p className={cn("text-xs leading-relaxed", muted)}>
          Perkiraan berapa lama keluarga dapat bertahan jika{" "}
          {lostLabel ? <b>{lostLabel}</b> : "penghasilan utama terbesar"} berhenti
          hari ini dan pola pengeluaran tetap sama.
        </p>
      )}
      <div className={cn("rounded-xl px-3 py-2 font-mono text-[11px]", calcBox)}>
        Dana Darurat {formatCompact(scenario.emergency)} ÷ Defisit{" "}
        {formatCompact(scenario.monthlyDeficit)}/bln ={" "}
        <b>{runwayFull(scenario.survivalRunway)}</b>
      </div>
    </div>
  );
}
